import { render, staticRenderFns } from "./NewTransactions.vue?vue&type=template&id=07393e56&scoped=true"
import script from "./NewTransactions.vue?vue&type=script&lang=js"
export * from "./NewTransactions.vue?vue&type=script&lang=js"
import style0 from "./NewTransactions.vue?vue&type=style&index=0&id=07393e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07393e56",
  null
  
)

export default component.exports